import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, setToken } from "@/lib/api";
import Logo from "@/components/Logo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      setToken(r.data.access_token);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background text-foreground flex items-center" data-testid="page-admin-login">
      <div className="container-tight w-full">
        <div className="flex items-center mb-10">
          <Logo className="h-14 w-auto" />
        </div>
        <div className="rounded-lg border border-brand-rule/70 bg-brand-cream p-8 sm:p-10">
          <div className="eyebrow mb-3">Admin</div>
          <h1 className="display text-[32px] mb-8">Sign in</h1>
          <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
            <div>
              <label className="block text-[12px] text-brand-ink/60 mb-1.5 uppercase tracking-wider">Email</label>
              <input
                required
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-email"
                className="w-full rounded-md border border-brand-rule bg-white/80 px-4 py-3 text-[15px] focus:outline-none focus:border-brand-blue"
              />
            </div>
            <div>
              <label className="block text-[12px] text-brand-ink/60 mb-1.5 uppercase tracking-wider">Password</label>
              <input
                required
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-password"
                className="w-full rounded-md border border-brand-rule bg-white/80 px-4 py-3 text-[15px] focus:outline-none focus:border-brand-blue"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="inline-flex items-center gap-2 rounded-full bg-brand-ink px-6 py-3 text-brand-cream text-[14px] hover:bg-brand-blue transition-colors disabled:opacity-60"
            >
              {loading ? "Signing in…" : "Sign in"} <span aria-hidden>→</span>
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
